import { render, staticRenderFns } from "./FormBuilderFieldError.vue?vue&type=template&id=f5736170&"
import script from "./FormBuilderFieldError.vue?vue&type=script&lang=js&"
export * from "./FormBuilderFieldError.vue?vue&type=script&lang=js&"
import style0 from "./FormBuilderFieldError.vue?vue&type=style&index=0&id=f5736170&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports